import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { Close as CloseIcon, HelpOutlined as HelpIcon } from '@mui/icons-material';
import { navigate } from '../lib/navigation';
import Button from './Button';

let dismissedForPageLoad = false;

function FloatingHelpButton() {
  const [visible, setVisible] = useState(!dismissedForPageLoad);

  if (!visible) return null;

  function dismiss() {
    dismissedForPageLoad = true;
    setVisible(false);
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        right: { xs: 16, sm: 24 },
        bottom: { xs: 16, sm: 24 },
        zIndex: (theme) => theme.zIndex.speedDial,
        borderRadius: 999,
        bgcolor: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 8px 24px rgba(47, 25, 107, 0.25)',
      }}
    >
      <Button
        startIcon={<HelpIcon />}
        onClick={() => navigate('/contact')}
        aria-label="Need help? Contact us"
        sx={{ borderRadius: 999, pl: 2, pr: 1, boxShadow: 'none', '&:hover': { boxShadow: 'none' } }}
      >
        Need help?
      </Button>
      <IconButton
        aria-label="Hide help button until refresh"
        size="small"
        onClick={dismiss}
        sx={{ color: 'white', mr: 0.75, '&:hover': { bgcolor: 'rgba(255,255,255,0.14)' } }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

export default FloatingHelpButton;
